export enum ROLE {
  USER = 'USER',
  ADMIN = 'ADMIN',
  SUPEROWNER = 'SUPEROWNER',
  SUPERADMIN = 'SUPERADMIN',
  OWNER = 'OWNER',
  USERKEEPME = 'USERKEEPME',
  KEEPME = 'KEEPME',
  BEACON = 'BEACON',
}

export enum MediaType {
  BOT_PROFILE = 'BOT_PROFILE',
  CLIENT_PROFILE = 'CLIENT_PROFILE',
  CLIENT_TEAM_PROFILE = 'CLIENT_TEAM_PROFILE',
  AGENT_ICON = 'AGENT_ICON',
  MASCOT_IMAGE = 'MASCOT_IMAGE',
  LOCATION_PROFILE = 'LOCATION_PROFILE',
  TEMPLATE = 'TEMPLATE',
}
export enum ACTION {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  VIEW = 'VIEW',
}

export enum Packages {
  bronze = 'Bronze',
  silver = 'Silver',
  gold = 'Gold',
  essentials = 'Essentials',
  connected = 'Connected',
  omni = 'Omni',
}

export enum Currency {
  US = 'US',
  UK = 'UK',
}

export enum Platform {
  // Nova
  welcomeLead = 'welcomeLead',
  confirmation = 'confirmation',
  followup = 'followup',
  noShow = 'noShow',
  noBooking = 'noBooking',
  noAppointment = 'noAppointment',
  feedback = 'feedback',
  reEngage = 'reEngage',
  noSale = 'noSale',
  cancellation = 'cancellation',

  // Atlas
  overdue = 'overdue',

  // Ember (retention)
  winbackOne = 'winbackOne',
  atRisk = 'atRisk',
  saveOffer = 'saveOffer',
  freezeOption = 'freezeOption',
}

export enum WeekDays {
  monday = 'MONDAY',
  tuesday = 'TUESDAY',
  wednesday = 'WEDNESDAY',
  thursday = 'THURSDAY',
  friday = 'FRIDAY',
  saturday = 'SATURDAY',
  sunday = 'SUNDAY',
}

export const TimeSlotDurations = [1, 5, 15, 30, 45, 60, 75, 90, 120];

export enum API_CONFIG {
  legend = 'legend',
  zoho = 'zoho',
  leisure_hub = 'leisureHub',
  zoho_mcp = 'zoho-mcp',
  keepme = 'keepme',
  gymsales = 'gymsales',
  glofox = 'glofox',
  perfectgym = 'perfectgym',
  magicline = 'magicline/perfectgym',
  resamania = 'resamania',
  google_calendar = 'google_calendar',
  hubspot = 'hubspot',
  centumx = 'centumx',
  gladstone = 'gladstone',
  mindbody = 'mindbody',
  evolutionWellness = 'evolutionWellness',
  calendly = 'calendly',
  acuity = 'acuity',
  purecrm = 'purecrm',
  atreemo = 'atreemo',
  nextgen = 'nextgen',
  dummyCRM = 'dummyCRM',
}

export const ArabicTimezones = ['Asia/Riyadh', 'Africa/Cairo', 'Asia/Dubai'];

export enum FORM_STATE {
  SUBMITTED = 'SUBMITTED',
  NOT_SUBMITTED = 'NOT_SUBMITTED',
}

// Automation rule channels. Every Rule/* component renders this list, so
// adding an entry here enables it across all nine automation types at once.
// The automation service lowercases these into its dispatch switch — 'Viber'
// becomes the `case "viber"` in services/bookConfirmation.js.
export const Channel = ['WhatsApp', 'SMS', 'Mail', 'Phone', 'Viber'];

export const ALLOWED_PROMPT_VARIABLES = new Set([
  'query',
  'tool_names',
  'chatbot_name',
  'org_name',
  'branch_name',
  'branch_address',
  'booking_instructions',
  'booking_instructions_2',
  'Time',
  'Today',
  'bookedFlag',
  'Day',
  'important',
  'flagBooked',
  'available_clubs',
  'callback_instructions',
  'email_reception_instructions',
  'callback_email_instructions',
  'gated_or_transparent_instructions',
  'duration',
  'member_prompt',
  'details',
  'membership_status',
  'metadata',
  'first_name',
]);

export const ALLOWED_REGION_RAG_PROMPT_VARIABLES = new Set([
  'question',
  'context',
  'language',
  'today',
  'time',
  'duration',
  'weekday',
  'metadata',
  'first_name',
]);

export const ALLOWED_LOCATION_RAG_PROMPT_VARIABLES = new Set([
  'question',
  'branch_name',
  'client_name',
  'context_club',
  'context_branch',
  'language',
  'today',
  'time',
  'weekday',
  'flag',
  'metadata',
  'first_name',
]);

export const ALLOWED_VOICE_PROMPT_VARIABLES = new Set([
  'chatbot_name',
  'org_name',
  'booking_type',
  'Time',
  'Today',
  'Day',
  'greeting_message',
  'enquiry_question',
  'metadata',
  'first_name',
]);

export enum STATE {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}
